import { render, staticRenderFns } from "./EditDragonTiger.vue?vue&type=template&id=67d085b8&"
import script from "./EditDragonTiger.vue?vue&type=script&lang=js&"
export * from "./EditDragonTiger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports